/* PDP photo viewer. A click, a single tap or Enter on the gallery opens the
   photo full screen on ivory; the 2x zoom lives in here. Figma: file
   ALxreNQSU6SSh2Uo8A39oC, page "PDP Photo Viewer", board 1195:230.

   The gallery owns which photos exist and in what order. This file never
   re-derives that: it asks window.AykahGallery (set up in product-page.js),
   so the colour, fabric and orientation filters decide here exactly as they
   do on the page, and a hidden colour can never appear in the viewer.

   History: opening adds one entry and zooming another, so the browser or
   phone Back button steps out one level at a time, the same as Esc. */
(function () {
  'use strict';
  if (window.AykahPhotoViewer) return; // loaded twice: bind once

  var root = document.querySelector('[data-photo-viewer]');
  if (!root) return;
  // Fixed positioning inside a sticky or transformed column would pin to
  // that column, not the screen, so the viewer lives at the end of <body>.
  document.body.appendChild(root);

  function $(sel) { return root.querySelector(sel); }
  var stage = $('[data-pv-stage]');
  var track = $('[data-pv-track]');
  var rail = $('[data-pv-rail]');
  var dotsEl = $('[data-pv-dots]');
  var btnClose = $('[data-pv-close]');
  var btnPrev = $('[data-pv-prev]');
  var btnNext = $('[data-pv-next]');
  var btnZoom = $('[data-pv-zoom]');
  var zoomLabel = $('[data-pv-zoom-label]');
  var countEl = $('[data-pv-count]');
  var contextEl = $('[data-pv-context]');
  var hintEl = $('[data-pv-hint]');
  var errorEl = $('[data-pv-error]');
  var retryBtn = $('[data-pv-retry]');
  var live = $('[data-pv-live]');
  var backdrop = $('[data-pv-backdrop]');
  var title = root.getAttribute('data-title') || '';
  var hintOn = root.getAttribute('data-hint') === 'true';

  var areaEl = document.createElement('div');
  areaEl.className = 'pv-area';
  areaEl.setAttribute('aria-hidden', 'true');
  stage.insertBefore(areaEl, track);

  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var ZOOM = 2;
  var touchMQ = window.matchMedia('(max-width: 1023px)');
  var fineMQ = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');

  var S = {
    open: false,
    busy: false,       // opening or closing animation in flight
    closing: false,
    session: 0,        // bumps on every open; late callbacks from an older one are ignored
    openTimer: 0,
    hintDelay: 0,
    photos: [],
    slides: [],
    i: 0,
    scale: 1,
    tx: 0,
    ty: 0,
    depth: 0,
    ignorePop: 0,
    failed: {},
    inerted: [],
    opener: null,
    padRight: '',
    hintTimer: 0,
    lastWheel: 0,
    lastClick: 0,
    navFocus: null
  };

  function touchMode() { return touchMQ.matches; }
  function reduced() { return reduceMQ.matches; }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  /* ── Reading the gallery ─────────────────────────────────────────── */
  function galleryImages() {
    var g = window.AykahGallery;
    if (g && typeof g.visibleImages === 'function') return g.visibleImages();
    return Array.prototype.filter.call(document.querySelectorAll('[data-main-image]'), function (im) {
      return !im.hidden;
    });
  }

  function collect() {
    return galleryImages().map(function (im) {
      var idx = parseInt(im.getAttribute('data-index'), 10);
      var thumb = document.querySelector('[data-thumbnail-btn][data-index="' + idx + '"] img');
      var zoom = im.getAttribute('data-zoom-src') || '';
      var srcset = im.getAttribute('data-srcset') || im.getAttribute('srcset') || '';
      if (zoom) srcset = srcset ? srcset + ', ' + zoom + ' 2000w' : zoom + ' 2000w';
      return {
        index: idx,
        // Already on screen and cached, so the first frame is never blank.
        now: im.currentSrc || im.getAttribute('src') || im.getAttribute('data-src') || '',
        src: im.getAttribute('data-src') || im.currentSrc || im.getAttribute('src') || '',
        srcset: srcset,
        zoom: zoom,
        alt: im.getAttribute('alt') || title,
        // The page copy is usually loaded already, so its shape is known
        // before the viewer's copy arrives and the photo never changes size
        // mid-animation.
        ar: im.naturalWidth && im.naturalHeight
          ? im.naturalWidth / im.naturalHeight
          : (thumb && thumb.naturalWidth && thumb.naturalHeight ? thumb.naturalWidth / thumb.naturalHeight : 0),
        thumb: thumb ? (thumb.currentSrc || thumb.getAttribute('src')) : (im.getAttribute('data-src') || '')
      };
    });
  }

  function colourName() {
    var g = window.AykahGallery;
    try { return g && g.colourName ? g.colourName() : ''; } catch (e) { return ''; }
  }

  function originRect() {
    var wrap = document.querySelector('[data-image-zoom]');
    if (!wrap) return null;
    var r = wrap.getBoundingClientRect();
    if (!r.width || !r.height || r.bottom < 0 || r.top > window.innerHeight) return null;
    return r;
  }

  /* ── Building ────────────────────────────────────────────────────── */
  function build() {
    track.textContent = '';
    rail.textContent = '';
    S.slides = S.photos.map(function (p, k) {
      var slide = document.createElement('div');
      slide.className = 'pv-slide';
      var img = document.createElement('img');
      img.className = 'pv-img';
      img.alt = p.alt;
      img.draggable = false;
      img.decoding = 'async';
      slide.appendChild(img);
      track.appendChild(slide);
      var entry = { el: slide, img: img, fit: null, upgraded: false, sharp: false };
      img.addEventListener('load', function () {
        if (S.open && S.slides[k] && S.slides[k].img === img) layoutSlide(k);
      });
      if (S.photos.length > 1) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pv-thumb';
        b.setAttribute('aria-label', 'Show photo ' + (k + 1) + ' of ' + S.photos.length);
        var t = document.createElement('img');
        t.src = p.thumb;
        t.alt = '';
        t.decoding = 'async';
        b.appendChild(t);
        b.addEventListener('click', function () { go(k); });
        rail.appendChild(b);
      }
      return entry;
    });
  }

  function ensureSrc(k) {
    var s = S.slides[k];
    if (!s || s.img.getAttribute('src')) return;
    s.img.src = S.photos[k].now || S.photos[k].src;
  }

  // Once a photo is showing, let the browser pick a sharp enough copy for
  // its real size on this screen. The old copy stays up until it arrives.
  function upgrade(k) {
    var s = S.slides[k];
    if (!s || s.upgraded || s.sharp) return;
    var p = S.photos[k];
    s.upgraded = true;
    if (p.srcset && s.fit) {
      s.img.setAttribute('sizes', Math.round(s.fit.w) + 'px');
      s.img.setAttribute('srcset', p.srcset);
    }
  }

  function preloadNeighbours() {
    ensureSrc(S.i - 1);
    ensureSrc(S.i + 1);
  }

  /* ── Layout ──────────────────────────────────────────────────────── */
  function setMode() {
    var touch = touchMode();
    root.classList.toggle('pv--touch', touch);
    root.classList.toggle('pv--desk', !touch);
    root.classList.toggle('pv--fine', fineMQ.matches);
  }

  function fitFor(k) {
    var a = areaEl.getBoundingClientRect();
    var img = S.slides[k].img;
    var ar = img.naturalWidth && img.naturalHeight
      ? img.naturalWidth / img.naturalHeight
      : (S.photos[k].ar || 0.8);
    var w = Math.min(a.width, a.height * ar);
    var h = w / ar;
    return { w: w, h: h, left: a.left + (a.width - w) / 2, top: a.top + (a.height - h) / 2 };
  }

  function layoutSlide(k) {
    var s = S.slides[k];
    if (!s) return;
    var f = fitFor(k);
    var old = s.fit;
    // A sharper copy of the same photo has the same shape. Leave the photo,
    // and any zoom or spring still running on it, alone.
    if (old && Math.abs(old.w - f.w) < 0.5 && Math.abs(old.h - f.h) < 0.5 &&
        Math.abs(old.left - f.left) < 0.5 && Math.abs(old.top - f.top) < 0.5) return;
    s.fit = f;
    s.img.style.width = f.w + 'px';
    s.img.style.height = f.h + 'px';
    s.img.style.left = f.left + 'px';
    s.img.style.top = f.top + 'px';
    // While opening or closing, the photo's transform belongs to that motion.
    if (k === S.i && !S.busy) {
      if (S.scale > 1) {
        var c = clampT(S.tx, S.ty, S.scale, f, false);
        S.tx = c.tx; S.ty = c.ty;
      }
      applyTransform(false);
    }
    // Arrows stay put between photos; they only step outward if a photo
    // turns out wider than any seen so far.
    if (f.w > (S.arrowMaxW || 0) + 0.5) placeArrows();
  }

  function layoutAll() {
    for (var k = 0; k < S.slides.length; k++) layoutSlide(k);
    placeTrack(false, 0);
    placeArrows();
  }

  function placeTrack(animate, dx) {
    if (!touchMode()) {
      track.style.transform = '';
      track.style.transition = '';
      S.slides.forEach(function (s, k) { s.el.classList.toggle('is-current', k === S.i); });
      return;
    }
    S.slides.forEach(function (s) { s.el.classList.remove('is-current'); });
    var w = stage.clientWidth;
    track.style.transition = animate && !reduced() ? 'transform 280ms ' + EASE : 'none';
    track.style.transform = 'translate3d(' + (-S.i * w + (dx || 0)) + 'px,0,0)';
  }

  // Arrows sit 40px outside the WIDEST photo and never move while browsing,
  // so a second click on Next lands on Next, not on the photo.
  function placeArrows() {
    var fits = S.slides.map(function (x) { return x.fit; }).filter(Boolean);
    if (!fits.length) return;
    var W = root.clientWidth;
    var a = areaEl.getBoundingClientRect();
    var cx = a.left + a.width / 2;
    var maxW = Math.max.apply(null, fits.map(function (f) { return f.w; }));
    var minLeft = Math.min.apply(null, fits.map(function (f) { return f.left; }));
    S.arrowMaxW = maxW;
    var railRight = 0;
    if (!touchMode() && S.photos.length > 1) railRight = rail.getBoundingClientRect().right;
    var prevX = touchMode() ? 8 : Math.max(railRight + 16, cx - maxW / 2 - 88);
    var nextX = touchMode() ? W - 48 : Math.min(W - 64, cx + maxW / 2 + 40);
    root.style.setProperty('--pv-prev-x', prevX + 'px');
    root.style.setProperty('--pv-next-x', nextX + 'px');
    root.style.setProperty('--pv-arrow-y', (a.top + a.height / 2) + 'px');
    // The counter and product line never run over the photo.
    root.style.setProperty('--pv-meta-max', Math.max(160, minLeft - 36) + 'px');
  }

  /* ── Zoom maths ──────────────────────────────────────────────────── */
  // Keeps a scaled photo covering the screen; an axis where the photo is
  // smaller than the screen stays centred. With rubber, a drag past an edge
  // gives a little and springs back on release.
  function clampT(tx, ty, s, f, rubber) {
    var W = root.clientWidth, H = root.clientHeight;
    function axis(t, pos, size, view) {
      var scaled = size * s;
      if (scaled <= view) return (view - scaled) / 2 - pos;
      var min = view - scaled - pos, max = -pos;
      if (t > max) return rubber ? max + (t - max) * 0.35 : max;
      if (t < min) return rubber ? min + (t - min) * 0.35 : min;
      return t;
    }
    return { tx: axis(tx, f.left, f.w, W), ty: axis(ty, f.top, f.h, H) };
  }

  function applyTransform(animate, ms) {
    var s = S.slides[S.i];
    if (!s) return;
    s.img.style.transition = animate && !reduced()
      ? 'transform ' + (ms || 220) + 'ms ' + EASE + ', border-radius 220ms ' + EASE
      : 'none';
    s.img.style.transform = 'translate3d(' + S.tx + 'px,' + S.ty + 'px,0) scale(' + S.scale + ')';
  }

  function zoomAround(s, cx, cy, animate, ms) {
    var f = S.slides[S.i] && S.slides[S.i].fit;
    if (!f) return;
    var u = (cx - f.left - S.tx) / S.scale;
    var v = (cy - f.top - S.ty) / S.scale;
    S.scale = s;
    if (s <= 1) { S.scale = 1; S.tx = 0; S.ty = 0; }
    else {
      var c = clampT(cx - f.left - s * u, cy - f.top - s * v, s, f, false);
      S.tx = c.tx; S.ty = c.ty;
    }
    applyTransform(animate, ms);
  }

  function zoomed() { return S.scale > 1.01; }

  function updateZoomUi() {
    var z = zoomed();
    root.classList.toggle('is-zoomed', z);
    btnZoom.setAttribute('aria-label', z ? '2\u00d7, zoom out to 1\u00d7' : '1\u00d7, zoom in to 2\u00d7');
    zoomLabel.textContent = z ? '2×' : '1×';
    btnZoom.disabled = !!S.failed[S.i];
  }

  function zoomIn(cx, cy) {
    if (zoomed() || S.failed[S.i]) return;
    var f = S.slides[S.i] && S.slides[S.i].fit;
    if (!f) return;
    if (cx == null) { cx = f.left + f.w / 2; cy = f.top + f.h / 2; }
    zoomAround(ZOOM, cx, cy, true);
    afterZoomIn();
  }

  function afterZoomIn() {
    // The rail and arrows are about to hide; never leave focus on them.
    var a = document.activeElement;
    if (a && root.contains(a) && a.closest('.pv-nav')) {
      S.navFocus = a;
      focusQuiet(btnZoom);
    }
    updateZoomUi();
    hideHint();
    pushTo(2);
    announce('Zoomed to 2 times');
    loadSharp(S.i);
  }

  function zoomOut(fromHistory) {
    if (!zoomed()) return;
    zoomAround(1, 0, 0, true);
    afterZoomOut(fromHistory);
  }

  function afterZoomOut(fromHistory) {
    updateZoomUi();
    if (S.navFocus && document.activeElement === btnZoom && root.contains(S.navFocus)) {
      var back = S.navFocus;
      window.setTimeout(function () { if (!back.disabled) focusQuiet(back); }, 0);
    }
    S.navFocus = null;
    if (!fromHistory) popTo(1);
    announce('Zoom reset');
  }

  // The 2000px copy loads only when zoom starts. Until it lands the page-size
  // copy stays up, slightly soft, and the zoom button shows a ring.
  function loadSharp(k) {
    var s = S.slides[k], p = S.photos[k];
    if (!s || s.sharp || !p.zoom) return;
    btnZoom.classList.add('is-loading');
    var sess = S.session;
    var pre = new Image();
    function stale() { return sess !== S.session || S.slides[k] !== s; }
    pre.onload = function () {
      if (stale()) return;
      s.sharp = true;
      s.img.removeAttribute('srcset');
      s.img.removeAttribute('sizes');
      s.img.src = p.zoom;
      if (k === S.i) btnZoom.classList.remove('is-loading');
    };
    pre.onerror = function () {
      if (stale() || k !== S.i) return;
      btnZoom.classList.remove('is-loading');
      S.failed[k] = true;
      var hadFocus = document.activeElement === btnZoom;
      zoomOut();
      updateZoomUi();
      errorEl.hidden = false;
      announce('The full-size photo did not load. Try again is available.');
      if (hadFocus) focusQuiet(retryBtn);
    };
    pre.src = p.zoom;
  }

  /* ── Browsing ────────────────────────────────────────────────────── */
  function go(k) {
    if (!S.open || k < 0 || k >= S.photos.length || k === S.i) {
      if (touchMode()) placeTrack(true, 0);
      return;
    }
    if (zoomed()) zoomOut();
    btnZoom.classList.remove('is-loading');
    errorEl.hidden = true;
    S.lastNav = Date.now();
    S.i = k;
    ensureSrc(k);
    layoutSlide(k);
    upgrade(k);
    preloadNeighbours();
    placeTrack(true, 0);
    renderNav();
    updateZoomUi();
    announce('Photo ' + (k + 1) + ' of ' + S.photos.length);
  }

  function renderNav() {
    var n = S.photos.length;
    countEl.textContent = (S.i + 1) + ' / ' + n;
    var a = document.activeElement;
    btnPrev.disabled = S.i === 0;
    btnNext.disabled = S.i === n - 1;
    // Reaching an end disables the arrow under keyboard focus; hand focus to
    // the other arrow so the ring and the screen reader keep their place.
    if (a === btnNext && btnNext.disabled) focusQuiet(btnPrev.disabled ? btnClose : btnPrev);
    if (a === btnPrev && btnPrev.disabled) focusQuiet(btnNext.disabled ? btnClose : btnNext);
    var thumbs = rail.children;
    for (var k = 0; k < thumbs.length; k++) {
      var cur = k === S.i;
      thumbs[k].setAttribute('aria-current', cur ? 'true' : 'false');
      // Scroll the rail itself; scrollIntoView could nudge the locked page.
      if (cur) {
        var top = thumbs[k].offsetTop, bottom = top + thumbs[k].offsetHeight;
        if (top < rail.scrollTop) rail.scrollTop = top - 4;
        else if (bottom > rail.scrollTop + rail.clientHeight) rail.scrollTop = bottom - rail.clientHeight + 4;
      }
    }
    // Up to 7 dots; the small ones at the ends mean there are more.
    railFades();
    dotsEl.textContent = '';
    if (n < 2) return;
    var shown = Math.min(7, n);
    var start = clamp(S.i - 3, 0, n - shown);
    var end = start + shown - 1;
    for (var j = start; j <= end; j++) {
      var d = document.createElement('span');
      d.className = 'pv-dot' +
        (j === S.i ? ' is-current' : '') +
        (j !== S.i && ((j === start && start > 0) || (j === end && end < n - 1)) ? ' is-edge' : '');
      dotsEl.appendChild(d);
    }
  }

  // Fade only the end of the rail that has more thumbnails beyond it.
  function railFades() {
    var top = rail.scrollTop > 1;
    var bottom = rail.scrollTop + rail.clientHeight < rail.scrollHeight - 1;
    rail.classList.toggle('is-fade-top', top);
    rail.classList.toggle('is-fade-bottom', bottom);
  }
  rail.addEventListener('scroll', railFades, { passive: true });

  /* ── History: Back steps out one level ───────────────────────────── */
  function pushTo(level) {
    while (S.depth < level) {
      try { history.pushState({ aykahPhotoViewer: S.depth + 1 }, ''); } catch (e) { return; }
      S.depth++;
    }
  }
  function popTo(level) {
    var n = S.depth - level;
    if (n <= 0) return;
    S.depth = level;
    S.ignorePop++;
    history.go(-n);
  }
  // The entry landed on says which level to show, so Back and Forward both
  // work: page = closed, 1 = open at 1x, 2 = zoomed.
  window.addEventListener('popstate', function (e) {
    if (S.ignorePop > 0) { S.ignorePop--; return; }
    var level = e.state && e.state.aykahPhotoViewer ? e.state.aykahPhotoViewer : 0;
    if (!S.open || S.closing) {
      // A viewer step left behind by a reload or a close, reached with Back
      // or Forward: step over it so Back never looks dead and Forward never
      // reopens a viewer that is gone.
      if (level) history.back();
      return;
    }
    if (level === 0) { S.depth = 0; close(true); }
    else if (level === 1) { S.depth = 1; if (zoomed()) zoomOut(true); }
    else { S.depth = 2; if (!zoomed()) zoomIn(); }
  });

  /* ── Page lock and focus ─────────────────────────────────────────── */
  function lockPage() {
    var html = document.documentElement;
    var gap = window.innerWidth - html.clientWidth;
    S.padRight = document.body.style.paddingRight;
    S.overflow = document.body.style.overflow;
    html.classList.add('pv-lock');
    // The site's own pop-ups (email capture) stay shut while a layer has set
    // this, so nothing can open on top of the viewer.
    document.body.style.overflow = 'hidden';
    if (gap > 0) document.body.style.paddingRight = gap + 'px';
    S.inerted = [];
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el === root || el.hasAttribute('inert') || /^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(el.tagName)) return;
      el.setAttribute('inert', '');
      S.inerted.push(el);
    });
  }
  function unlockPage() {
    document.documentElement.classList.remove('pv-lock');
    document.body.style.paddingRight = S.padRight;
    document.body.style.overflow = S.overflow || '';
    S.inerted.forEach(function (el) { el.removeAttribute('inert'); });
    S.inerted = [];
  }
  function focusables() {
    return Array.prototype.filter.call(root.querySelectorAll('button:not([disabled])'), function (el) {
      if (!el.offsetWidth && !el.offsetHeight) return false;
      var cs = window.getComputedStyle(el);
      return cs.visibility !== 'hidden';
    });
  }
  function trapTab(e) {
    var list = focusables();
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (list.indexOf(document.activeElement) === -1) { e.preventDefault(); first.focus(); }
  }
  function focusQuiet(el) {
    if (!el || !el.focus) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  function announce(msg) {
    live.textContent = '';
    window.setTimeout(function () { live.textContent = msg; }, 60);
  }

  /* ── First-time hint (theme setting, off by default) ─────────────── */
  function maybeHint() {
    if (!hintOn) return;
    try {
      if (window.sessionStorage.getItem('aykahPvHint')) return;
      window.sessionStorage.setItem('aykahPvHint', '1');
    } catch (e) { /* private mode: still show it once for this open */ }
    hintEl.textContent = touchMode() ? 'Double-tap to zoom' : 'Click to zoom';
    hintEl.hidden = false;
    window.requestAnimationFrame(function () { hintEl.classList.add('is-shown'); });
    S.hintTimer = window.setTimeout(hideHint, 2800);
  }
  function hideHint() {
    window.clearTimeout(S.hintTimer);
    if (hintEl.hidden) return;
    hintEl.classList.remove('is-shown');
    window.setTimeout(function () { hintEl.hidden = true; }, 240);
  }

  /* ── Open and close ──────────────────────────────────────────────── */
  // The page shows the photo cropped to fill its box (object-fit: cover), so
  // the flight starts and ends at that crop: scaled to cover, clipped to the
  // visible part, then opening out to the whole photo.
  function flipFrom(rect, f) {
    var s = Math.max(rect.width / f.w, rect.height / f.h);
    var dx = rect.left + (rect.width - f.w * s) / 2 - f.left;
    var dy = rect.top + (rect.height - f.h * s) / 2 - f.top;
    var ix = Math.max(0, (f.w - rect.width / s) / 2);
    var iy = Math.max(0, (f.h - rect.height / s) / 2);
    return {
      transform: 'translate3d(' + dx + 'px,' + dy + 'px,0) scale(' + s + ')',
      clip: 'inset(' + iy + 'px ' + ix + 'px round ' + (12 / s) + 'px)'
    };
  }
  function restingClip() { return touchMode() ? 'inset(0px round 0px)' : 'inset(0px round 8px)'; }

  // While the photo is in flight, the copy on the page is hidden so there
  // are never two sofas on screen.
  function hidePageImage(index) {
    showPageImage();
    var im = document.querySelector('[data-main-image][data-index="' + index + '"]');
    if (im) { im.style.visibility = 'hidden'; S.pageImg = im; }
  }
  function showPageImage() {
    if (S.pageImg) { S.pageImg.style.visibility = ''; S.pageImg = null; }
  }

  function open(opts) {
    if (S.open || S.closing) return false;
    // A pinch-zoomed page would lay the fixed viewer out against the zoomed
    // viewport; let the gallery's own zoom answer instead.
    if (window.visualViewport && window.visualViewport.scale > 1.05) return false;
    var photos = collect();
    if (!photos.length) return false;
    var want = opts && typeof opts.index === 'number' ? opts.index : 0;
    var pos = 0;
    photos.forEach(function (p, k) { if (p.index === want) pos = k; });

    S.photos = photos;
    S.i = pos;
    S.scale = 1; S.tx = 0; S.ty = 0;
    S.failed = {};
    S.opener = document.activeElement;
    pts = {};
    G = null;
    errorEl.hidden = true;
    btnZoom.classList.remove('is-loading');

    build();
    setMode();
    root.classList.add('pv--instant');
    root.classList.toggle('pv--single', photos.length < 2);
    var colour = colourName();
    contextEl.textContent = colour ? title + '  ·  ' + colour : title;

    lockPage();
    root.hidden = false;
    ensureSrc(S.i);
    preloadNeighbours();
    layoutAll();
    renderNav();
    updateZoomUi();

    S.open = true;
    S.busy = true;
    S.session++;
    pushTo(1);

    var cur = S.slides[S.i];
    var from = originRect();
    var flying = !!(from && cur.fit && !reduced());
    if (flying) {
      var fl = flipFrom(from, cur.fit);
      cur.img.style.transition = 'none';
      cur.img.style.transform = fl.transform;
      cur.img.style.clipPath = fl.clip;
      hidePageImage(S.photos[S.i].index);
    }
    // Force the start state to be computed, then move to the end state in the
    // same task. No animation frame is awaited: a tab that is not painting
    // would otherwise never get the open class, and the controls would stay
    // hidden and unfocusable.
    root.getBoundingClientRect();
    cur.img.getBoundingClientRect();
    root.classList.add('is-open');
    if (flying) {
      cur.img.style.transition = 'transform 320ms ' + EASE + ', clip-path 320ms ' + EASE;
      cur.img.style.transform = 'translate3d(0,0,0) scale(1)';
      cur.img.style.clipPath = restingClip();
    }
    var sess = S.session;
    S.openTimer = window.setTimeout(function () {
      if (sess !== S.session || S.closing) return;
      S.busy = false;
      root.classList.remove('pv--instant');
      cur.img.style.clipPath = '';
      showPageImage();
      upgrade(S.i);
    }, reduced() ? 160 : 340);

    focusQuiet(btnClose);
    announce('Photo ' + (S.i + 1) + ' of ' + S.photos.length);
    S.hintDelay = window.setTimeout(maybeHint, reduced() ? 0 : 340);
    return true;
  }

  function close(fromHistory) {
    // Closing is always allowed, even mid-open: focus lands on X at once,
    // so X and Esc must answer at once.
    if (!S.open || S.closing) return;
    window.clearTimeout(S.openTimer);
    window.clearTimeout(S.hintDelay);
    S.closing = true;
    S.busy = true;
    if (!fromHistory) popTo(0);
    else S.depth = 0;
    hideHint();
    errorEl.hidden = true;

    // The page gallery lands on the photo the shopper stopped at.
    var p = S.photos[S.i];
    var g = window.AykahGallery;
    if (p && g && typeof g.select === 'function') {
      try { g.select(p.index, { instant: true }); } catch (e) { /* the page keeps its photo */ }
    }

    var cur = S.slides[S.i];
    var to = originRect();
    root.classList.remove('is-open', 'is-dragging', 'is-gesturing');
    backdrop.style.opacity = '';
    if (cur && cur.fit && to && !reduced()) {
      var fl = flipFrom(to, cur.fit);
      if (!cur.img.style.clipPath) cur.img.style.clipPath = restingClip();
      cur.img.getBoundingClientRect();
      cur.img.style.transition = 'transform 260ms ' + EASE + ', clip-path 260ms ' + EASE;
      cur.img.style.transform = fl.transform;
      cur.img.style.clipPath = fl.clip;
      if (p) hidePageImage(p.index);
    }
    window.setTimeout(finishClose, reduced() ? 160 : 270);
  }

  function finishClose() {
    root.hidden = true;
    root.classList.remove('is-zoomed', 'pv--instant');
    showPageImage();
    unlockPage();
    track.textContent = '';
    rail.textContent = '';
    dotsEl.textContent = '';
    S.slides = [];
    S.open = false;
    S.busy = false;
    S.closing = false;
    S.session++;
    S.scale = 1; S.tx = 0; S.ty = 0;
    var back = S.opener && S.opener !== document.body && document.body.contains(S.opener)
      ? S.opener
      : document.querySelector('[data-image-zoom]');
    focusQuiet(back);
  }

  /* ── Controls ────────────────────────────────────────────────────── */
  btnClose.addEventListener('click', function () { close(); });
  btnPrev.addEventListener('click', function () { go(S.i - 1); });
  btnNext.addEventListener('click', function () { go(S.i + 1); });
  btnZoom.addEventListener('click', function () { if (zoomed()) zoomOut(); else zoomIn(); });
  retryBtn.addEventListener('click', function () {
    delete S.failed[S.i];
    errorEl.hidden = true;
    updateZoomUi();
    zoomIn();
  });

  // On the document, not the viewer: keys must work even if focus has
  // somehow ended up outside it.
  document.addEventListener('keydown', function (e) {
    if (!S.open) return;
    var k = e.key;
    hideHint();
    if (k === 'Escape') { e.preventDefault(); if (zoomed()) zoomOut(); else close(); return; }
    if (k === 'Tab') { trapTab(e); return; }
    if (e.ctrlKey || e.metaKey || e.altKey) return; // browser zoom and shortcuts stay the browser's
    var z = zoomed(), step = 80;
    if (k === 'ArrowLeft') { e.preventDefault(); if (z) pan(step, 0); else go(S.i - 1); }
    else if (k === 'ArrowRight') { e.preventDefault(); if (z) pan(-step, 0); else go(S.i + 1); }
    else if (k === 'ArrowUp' && z) { e.preventDefault(); pan(0, step); }
    else if (k === 'ArrowDown' && z) { e.preventDefault(); pan(0, -step); }
    else if (k === '+' || k === '=') { e.preventDefault(); zoomIn(); }
    else if (k === '-' || k === '_') { e.preventDefault(); zoomOut(); }
  });

  function pan(dx, dy) {
    var f = S.slides[S.i] && S.slides[S.i].fit;
    if (!f) return;
    var c = clampT(S.tx + dx, S.ty + dy, S.scale, f, false);
    S.tx = c.tx; S.ty = c.ty;
    applyTransform(true, 160);
  }

  // Page side: the expand button over the gallery photo.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-photo-viewer-open]');
    if (!b) return;
    e.preventDefault();
    var g = window.AykahGallery;
    open({ index: g && g.currentIndex ? g.currentIndex() : 0 });
  });

  /* ── Pointer gestures on the stage ───────────────────────────────────
     One finger or the mouse: drag at 2x moves the photo; at 1x on a phone a
     sideways drag changes photo and a downward drag closes. Two fingers
     pinch, overshooting while down and settling at exactly 1x or 2x. */
  var pts = {};
  var G = null;
  var lastTap = { t: 0, x: 0, y: 0 };

  function ptCount() { return Object.keys(pts).length; }
  function mid() {
    var ks = Object.keys(pts), a = pts[ks[0]], b = pts[ks[1]];
    return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2, d: Math.hypot(a.x - b.x, a.y - b.y) || 1 };
  }
  function onImage(target) {
    var s = S.slides[S.i];
    return !!s && target === s.img;
  }

  stage.addEventListener('pointerdown', function (e) {
    if (!S.open || S.busy) return;
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    hideHint();
    pts[e.pointerId] = { x: e.clientX, y: e.clientY };
    try { stage.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
    var f = S.slides[S.i] && S.slides[S.i].fit;
    if (!f) return;
    if (ptCount() === 2) {
      if (G && (G.kind === 'swipe' || G.base)) placeTrack(false, 0);
      if (G && G.kind === 'dismiss') {
        backdrop.style.transition = '';
        backdrop.style.opacity = '';
        S.slides[S.i].img.style.transition = 'none';
        S.slides[S.i].img.style.transform = 'translate3d(' + S.tx + 'px,' + S.ty + 'px,0) scale(' + S.scale + ')';
      }
      var m = mid();
      G = { kind: 'pinch', d0: m.d, s0: S.scale, tx0: S.tx, ty0: S.ty, u: (m.x - f.left - S.tx) / S.scale, v: (m.y - f.top - S.ty) / S.scale };
      root.classList.add('is-gesturing');
      return;
    }
    if (ptCount() > 2) return;
    // A flick through the photos can start while the last slide is still
    // settling: pick the track up where it is on screen, not where it is going.
    var base = 0;
    if (touchMode() && window.DOMMatrixReadOnly) {
      var live = new DOMMatrixReadOnly(window.getComputedStyle(track).transform).m41;
      base = live + S.i * stage.clientWidth;
      if (Math.abs(base) > 0.5) placeTrack(false, base);
    }
    G = {
      kind: 'pending', x0: e.clientX, y0: e.clientY, t0: Date.now(), touch: e.pointerType === 'touch', base: base,
      tx0: S.tx, ty0: S.ty, target: e.target, dx: 0, dy: 0
    };
  });

  stage.addEventListener('pointermove', function (e) {
    if (!G || !pts[e.pointerId]) return;
    pts[e.pointerId] = { x: e.clientX, y: e.clientY };
    var f = S.slides[S.i] && S.slides[S.i].fit;
    if (!f) return;

    if (G.kind === 'pinch') {
      if (ptCount() < 2) return;
      var m = mid();
      var s = clamp(G.s0 * m.d / G.d0, 0.85, 2.4);
      G.mx = m.x; G.my = m.y;
      S.scale = s;
      S.tx = m.x - f.left - s * G.u;
      S.ty = m.y - f.top - s * G.v;
      applyTransform(false);
      root.classList.toggle('is-zoomed', s > 1.01);
      e.preventDefault();
      return;
    }

    var dx = e.clientX - G.x0, dy = e.clientY - G.y0;
    G.dx = dx; G.dy = dy;
    if (G.kind === 'pending') {
      var dist = Math.hypot(dx, dy), adx = Math.abs(dx), ady = Math.abs(dy);
      if (dist < 10) return;
      // Commit to an axis only once it is clear; a diagonal start waits
      // until the finger has travelled far enough to say which it meant.
      var horizontal = adx > ady * 1.3, vertical = ady > adx * 1.3;
      if (!zoomed() && !horizontal && !vertical) {
        if (dist < 24) return;
        horizontal = adx >= ady; vertical = !horizontal;
      }
      if (zoomed()) G.kind = 'pan';
      else if (horizontal && touchMode()) G.kind = 'swipe';
      else if (horizontal && G.touch) G.kind = 'flick';
      else if (vertical && touchMode() && dy > 0) G.kind = 'dismiss';
      else { G.kind = 'none'; return; }
      root.classList.add('is-gesturing');
      if (G.kind === 'pan') root.classList.add('is-dragging');
    }

    if (G.kind === 'pan') {
      var c = clampT(G.tx0 + dx, G.ty0 + dy, S.scale, f, true);
      S.tx = c.tx; S.ty = c.ty;
      applyTransform(false);
    } else if (G.kind === 'swipe') {
      var n = S.photos.length;
      var atEnd = (S.i === 0 && dx > 0) || (S.i === n - 1 && dx < 0);
      placeTrack(false, G.base + (atEnd ? dx * 0.35 : dx));
    } else if (G.kind === 'dismiss') {
      var H = root.clientHeight;
      var p = clamp(dy / H, 0, 1);
      var sc = 1 - 0.2 * clamp(dy / (H / 2), 0, 1);
      var img = S.slides[S.i].img;
      img.style.transition = 'none';
      img.style.transform = 'translate3d(' + (f.w * (1 - sc) / 2) + 'px,' + dy + 'px,0) scale(' + sc + ')';
      backdrop.style.transition = 'none';
      backdrop.style.opacity = String(1 - p * 1.2);
    }
    e.preventDefault();
  }, { passive: false });

  function endPointer(e, cancelled) {
    if (!pts[e.pointerId]) return;
    delete pts[e.pointerId];
    if (!G) return;
    var f = S.slides[S.i] && S.slides[S.i].fit;

    if (G.kind === 'pinch') {
      var mx = G.mx, my = G.my;
      if (cancelled) {
        // The browser took the pinch away: put the photo back exactly as it
        // was before the fingers landed. No zoom change, no history step.
        S.scale = G.s0; S.tx = G.tx0; S.ty = G.ty0;
        G = ptCount() >= 1 ? { kind: 'none' } : null;
        applyTransform(true, 200);
        root.classList.remove('is-gesturing');
        updateZoomUi();
        return;
      }
      if (ptCount() >= 1) { G = { kind: 'none' }; }
      settlePinch(f, mx, my);
      if (ptCount() === 0) G = null;
      return;
    }
    if (ptCount() > 0) return;
    var g = G;
    G = null;
    root.classList.remove('is-gesturing', 'is-dragging');
    if (!f) return;
    // The track was picked up mid-settle; anything but a swipe puts it back.
    if (g.base && g.kind !== 'swipe') placeTrack(true, 0);
    var dt = Math.max(1, Date.now() - g.t0);

    if (cancelled) {
      // The browser took the gesture away (a call, a system swipe): undo
      // whatever was in progress, never change photo or close.
      if (g.kind === 'swipe') placeTrack(true, 0);
      if (g.kind === 'dismiss') {
        backdrop.style.transition = '';
        backdrop.style.opacity = '';
        S.slides[S.i].img.style.transition = 'transform 200ms ' + EASE;
        S.slides[S.i].img.style.transform = 'translate3d(0,0,0) scale(1)';
      }
      if (g.kind !== 'pan') return;
    }
    if (g.kind === 'pan') {
      var c = clampT(S.tx, S.ty, S.scale, f, false);
      var sprung = c.tx !== S.tx || c.ty !== S.ty;
      S.tx = c.tx; S.ty = c.ty;
      applyTransform(true, sprung ? (touchMode() ? 200 : 120) : 1);
    } else if (g.kind === 'swipe') {
      var W = stage.clientWidth, v = g.dx / dt;
      if ((g.dx < -W * 0.2 || v < -0.35) && S.i < S.photos.length - 1) go(S.i + 1);
      else if ((g.dx > W * 0.2 || v > 0.35) && S.i > 0) go(S.i - 1);
      else placeTrack(true, 0);
    } else if (g.kind === 'flick') {
      if (g.dx < -50) go(S.i + 1);
      else if (g.dx > 50) go(S.i - 1);
    } else if (g.kind === 'dismiss') {
      var H = root.clientHeight, vy = g.dy / dt;
      backdrop.style.transition = '';
      if (g.dy > Math.min(120, H / 3) || vy > 0.5) { close(); }
      else {
        backdrop.style.opacity = '';
        root.classList.add('is-open');
        S.slides[S.i].img.style.transition = 'transform 200ms ' + EASE;
        S.slides[S.i].img.style.transform = 'translate3d(0,0,0) scale(1)';
      }
    } else if (g.kind === 'pending' && dt < 400) {
      tap(e, g);
    }
  }
  stage.addEventListener('pointerup', endPointer);
  stage.addEventListener('pointercancel', function (e) {
    if (G && G.kind === 'pending') G.kind = 'none';
    endPointer(e, true);
  });

  function settlePinch(f, mx, my) {
    if (!f) return;
    var wasZoomed = S.depth >= 2;
    var target = S.scale >= 1.5 ? ZOOM : 1;
    // Settle around the point between the fingers, so the detail being
    // pinched stays under them.
    var cx = mx != null ? mx : f.left + S.tx + (f.w * S.scale) / 2;
    var cy = my != null ? my : f.top + S.ty + (f.h * S.scale) / 2;
    if (target === 1) {
      S.scale = 1; S.tx = 0; S.ty = 0;
      applyTransform(true, 200);
      updateZoomUi();
      if (wasZoomed) afterZoomOut(false);
    } else {
      var u = (cx - f.left - S.tx) / S.scale, v = (cy - f.top - S.ty) / S.scale;
      var c = clampT(cx - f.left - ZOOM * u, cy - f.top - ZOOM * v, ZOOM, f, false);
      S.scale = ZOOM; S.tx = c.tx; S.ty = c.ty;
      applyTransform(true, 200);
      if (!wasZoomed) afterZoomIn(); else updateZoomUi();
    }
    root.classList.remove('is-gesturing');
  }

  // Desktop: one click on the photo toggles 2x. Phone: a double-tap does,
  // and a single tap does nothing, so a stray touch never zooms.
  function tap(e, g) {
    if (!onImage(g.target)) {
      // Clicking the empty ivory around the photo leaves, as in any lightbox.
      if (!touchMode() && !zoomed()) close();
      return;
    }
    if (!touchMode()) {
      if (Date.now() - (S.lastNav || 0) < 350) return; // a quick second arrow click, not a zoom
      var t = Date.now();
      if (t - S.lastClick < 320) return; // a double-click is one intent, not zoom in then out
      S.lastClick = t;
      if (zoomed()) zoomOut(); else zoomIn(e.clientX, e.clientY);
      return;
    }
    var now = Date.now();
    if (now - lastTap.t < 300 && Math.hypot(e.clientX - lastTap.x, e.clientY - lastTap.y) < 30) {
      lastTap.t = 0;
      if (zoomed()) zoomOut(); else zoomIn(e.clientX, e.clientY);
    } else {
      lastTap = { t: now, x: e.clientX, y: e.clientY };
    }
  }

  // Mouse wheel and trackpad: at 2x they move the photo; a trackpad pinch
  // (ctrl + wheel) zooms in or out.
  stage.addEventListener('wheel', function (e) {
    if (!S.open) return;
    e.preventDefault();
    var f = S.slides[S.i] && S.slides[S.i].fit;
    if (!f) return;
    if (e.ctrlKey) {
      var now = Date.now();
      if (now - S.lastWheel < 350) return;
      S.lastWheel = now;
      if (e.deltaY < 0) zoomIn(e.clientX, e.clientY); else zoomOut();
      return;
    }
    if (!zoomed()) return;
    var c = clampT(S.tx - e.deltaX, S.ty - e.deltaY, S.scale, f, false);
    S.tx = c.tx; S.ty = c.ty;
    applyTransform(false);
  }, { passive: false });

  /* ── Resize and rotate ───────────────────────────────────────────── */
  var resizeFrame = 0;
  window.addEventListener('resize', function () {
    if (!S.open) return;
    window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(function () {
      if (zoomed()) zoomOut();
      setMode();
      layoutAll();
      renderNav();
    });
  });

  if (history.state && history.state.aykahPhotoViewer) {
    try { history.replaceState(null, ''); } catch (e) { /* ignore */ }
  }

  window.AykahPhotoViewer = {
    open: open,
    close: function () { close(); },
    isOpen: function () { return S.open; }
  };
})();
